export const LanguageCookieName = 'i18n';
